import { EsDataType } from '../enums';

export const columns = {
  externalIntegrationReferenceId: {
    name: 'External Integration Reference ID',
    type: EsDataType.KEYWORD,
    hidden: true,
  },
};
